import React, { useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { sizes } from 'src/styles/Media.styled';
import {
    EmailContainer,
    PhoneContainer,
    SpecialityGrid,
    ProductGuideListContainer,
    ProductGuideListContainerHeader,
    HeaderContainer,
    HeaderTextContainer,
    PaginationContainer,
    PaginationContainerMobile,
    AccountPaginationWrapper,
    BodyGridContainer,
    SearchBoxContainer,
    BodyTextContainer,
    CityGrid,
    DesktopView,
    MobileView,
    EmailPhoneGrid,
    HeaderTextContainer1,
} from './associatedPhysicianCard.styled';
import { AccountDetailsContainer } from 'src/pages/more/pages/accounts/components/accountList/index.styled';
import PhysicianDetails from 'src/pages/more/pages/physicians/components/physicianDetails';
import Spinner from 'src/common/refactoredComponents/spinner/Spinner';
import {
    accountNumberZeroTrimmer,
} from 'src/utils/util';
import ModalDialog from 'src/common/refactoredComponents/modalDialog/modalDialog';
import { getFormattedPhoneNumber } from 'src/utils/util';
import SearchBox from 'src/common/refactoredComponents/searchbox/index';
import BasicPagination from 'src/common/refactoredComponents/paginator';
import { getAdminPhysicianList } from 'src/pages/admin/redux/action/index.js';
import { useTranslation } from 'react-i18next';
import {
    getPhysicianDetailss,
    setShowUnsavedPhysician,
    closePhysicianPopUP,
    setSelectedPhysician,
    setPhysicianDetailTabAction,
} from 'src/pages/more/redux/actions';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';
const AssociatedPhysician = (props) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const [searchValue, setSearchValue] = useState('');
    const [page, setPage] = useState(0);
    const [first, setFirst] = useState(0);
    const [, setIsEnter] = useState(false);
    const [showPopup, setShowPopup] = useState(false);
    const [physicianDetail, setPhysicianDetail] = useState([]);
    const winWidth = window.innerWidth;
    const associatedPhysician = useSelector(
        (state) => state.AdminReducer.associatedPhysician
    );

    const totalAssociatedPhysician = useSelector(
        (state) => state.AdminReducer.totalAssociatedPhysician
    );
    const commonUnsavedchanges = useSelector(
        (state) => state.accountReducer.commonUnsavedchangesPhysician
    );
    const loading = useSelector(
        (state) => state.AdminReducer.associatedPhysicianStatus
    );
    const physicianDropdownZGMorePhysicianVisibility = useSelector(
        (state) => state.loginReducer
    );
    const salesOrg = useSelector((state) => state.loginReducer.salesOrg);
    const countryISOCode = useSelector(
        (state) => state.loginReducer.hybrisUserDetails.countryISOCode
    );
    const physicianDetailsRef = useRef();
    const updateSearch = (val) => {
        setIsEnter(false);
        setSearchValue(val);
        let param = {
            physicianName: val,
            principalUser: props.userData.networkIdName,
        };

        dispatch(getAdminPhysicianList(param, salesOrg, countryISOCode));
    };
    const handleClick = (physician) => {
        dispatch(
            setPhysicianDetailTabAction({ selectedTabId: 'physicianDetails' })
        );

        dispatch(
            getPhysicianDetailss({
                accountId: physician.physicianId,
                salesOrg: salesOrg,
                countryISOCode: countryISOCode,
            })
        );
        dispatch(setSelectedPhysician(physician));
        setPhysicianDetail(physician);
        setShowPopup(true);
        physician;
    };
    const handleClose = () => {
        if (commonUnsavedchanges) {
            dispatch(setShowUnsavedPhysician(true));
        } else {
            // dispatch(showAccountDetails(false));
            setShowPopup(false);

            dispatch(closePhysicianPopUP(true));
        }
    };
    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            event.target.blur();
            // dispatch(searchProducts({ searchTerm: event.target.value }));
            setIsEnter(true);
            let param = {
                physicianName: searchValue && searchValue.trim(),
                principalUser: props.userData.networkIdName,
            };

            dispatch(getAdminPhysicianList(param, salesOrg, countryISOCode));
        }
    };
    useEffectWithErrorLogging(() => {
        const param = {
            pageNum: page,
            principalUser: props.userData.networkIdName,
            physicianName: searchValue !== '' ? searchValue : '',
        };

        dispatch(getAdminPhysicianList(param, salesOrg, countryISOCode));
    }, [page]);

    const handleClearSearch = () => {
        // if (isEnter) {
        setPage(0);
        setFirst(0);
        const param = {
            pageNum: page,
            principalUser: props.userData.networkIdName,
        };
        dispatch(getAdminPhysicianList(param, salesOrg, countryISOCode));
        //}
    };
    const onPageChange = (event) => {
        setFirst(event.first);
        setPage(event.page);
    };
    return (
        <>
            <ProductGuideListContainerHeader>
                <SearchBoxContainer>
                    <SearchBox
                        id="admin-nameDetails-associatedPhysicianCard-searchbox"
                        margin={'auto 0px auto 0px'}
                        marginDesktop={'15px 0 8px'}
                        updateSearch={updateSearch}
                        searchProduct={searchValue}
                        placeholder={t('admin.adminList.search')}
                        width={
                            winWidth <= sizes.mobileDevice ? '100%' : '345px'
                        }
                        //containerMobileWidth={'345px'}
                        height={'40px'}
                        borderRadius={'20px'}
                        paddingLeft={'2.2rem'}
                        isSearchIcon={true}
                        searchIconWidth={'min-content'}
                        fontSize={'14px'}
                        handleKeyPress={handleKeyPress}
                        clearSearch={handleClearSearch}
                        background={'none'}
                        enterkeyhint={'go'}
                        borderLeft={'none'}
                    />
                </SearchBoxContainer>

                <HeaderContainer
                    container
                    justifyContent={'space-between'}
                    direction="row"
                >
                    <HeaderTextContainer
                        item
                        xs={12}
                        sm={3}
                        md={3}
                        lg={3}
                        xl={3}
                        mobile={12}
                        key="accountName"
                    >
                        {t('admin.nameDetails.physician')}
                    </HeaderTextContainer>
                    <HeaderTextContainer
                        item
                        xs={12}
                        sm={3}
                        md={3}
                        lg={3}
                        xl={3}
                        mobile={12}
                        key="accountNumber"
                    >
                        {t('admin.nameDetails.speciality')}
                    </HeaderTextContainer>
                    <HeaderTextContainer
                        item
                        xs={12}
                        sm={3}
                        md={3}
                        lg={3}
                        xl={3}
                        mobile={12}
                        key="city"
                    >
                        {t('admin.nameDetails.cityState')}
                    </HeaderTextContainer>
                    <HeaderTextContainer1
                        item
                        xs={12}
                        sm={3}
                        md={3}
                        lg={3}
                        xl={3}
                        mobile={12}
                        key="district"
                    >
                        {t('admin.nameDetails.emailPhone')}
                    </HeaderTextContainer1>
                </HeaderContainer>
            </ProductGuideListContainerHeader>

            <ProductGuideListContainer>
                {loading === true ? (
                    // <Spinner animation="border" variant="primary"></Spinner>
                    // <Backdrop
                    //     showCloseButton={false}
                    //     showBackdrop={true}
                    //     isModal
                    //     loaderBackground
                    // >
                    <Spinner
                        id="admin-associatedPhysicianCard-nameDetails-loadingSpinner"
                        animation="border"
                        variant="primary"
                        small
                    ></Spinner>
                ) : // </Backdrop>
                null}
                {associatedPhysician &&
                    associatedPhysician.map((physician, index) => {
                        return (
                            <BodyGridContainer
                                id={`admin-associatedPhysicianCard-row-${index}`}
                                container
                                justifyContent={'space-between'}
                                direction="row"
                                key={index}
                                onClick={() => handleClick(physician)}
                            >
                                <BodyTextContainer
                                    item
                                    xs={12}
                                    sm={3}
                                    md={3}
                                    lg={3}
                                    xl={3}
                                    mobile={12}
                                    key="accountName"
                                >
                                    <div>
                                        <a
                                            id={`admin-associatedPhysicianCard-name-${index}`}
                                        >
                                            {' '}
                                            <span
                                                style={{
                                                    fontFamily:
                                                        'AvenirNextWorld Demi',
                                                    cursor: 'pointer',
                                                }}
                                            >
                                                {physician.firstName}{' '}
                                                {physician.lastName}
                                            </span>
                                        </a>{' '}
                                        <br></br>
                                        <span
                                            style={{
                                                color: '#000000',
                                                fontFamily:
                                                    'AvenirNextWorld Regular',
                                            }}
                                        >
                                            {' '}
                                            {/* {t(
                                                'admin.associatedPhysician.hcpId'
                                            )} */}
                                            {(salesOrg==='S024' || countryISOCode ==='JP')?t(
                                                'admin.associatedPhysician.sapId'
                                            ):t(
                                                'admin.associatedPhysician.hcpId'
                                            )}
                                            <span style={{ marginLeft: '4px' }}>
                                            {physicianDropdownZGMorePhysicianVisibility === 'VISIBLE'?accountNumberZeroTrimmer(physician.physicianId):physician.hcpId}
                                        
                                                {/* {physician.hcpId} */}
                                            </span>
                                        </span>
                                    </div>
                                </BodyTextContainer>
                                <SpecialityGrid
                                    item
                                    xs={12}
                                    sm={3}
                                    md={3}
                                    lg={3}
                                    xl={3}
                                    mobile={12}
                                    key="accountNumber"
                                    // key="favourite"
                                >
                                    {physician.specialty}
                                </SpecialityGrid>
                                <CityGrid
                                    item
                                    xs={12}
                                    sm={3}
                                    md={3}
                                    lg={3}
                                    xl={3}
                                    mobile={12}
                                >
                                    {physician.city && physician.city}
                                    {physician.state && ', '}
                                    {physician.state && physician.state}
                                </CityGrid>
                                <EmailPhoneGrid
                                    item
                                    xs={12}
                                    sm={3}
                                    md={3}
                                    lg={3}
                                    xl={3}
                                    mobile={12}
                                >
                                    <EmailContainer>
                                        {physician.email ? physician.email : ''}
                                    </EmailContainer>
                                    <PhoneContainer>
                                        {physician.phone
                                            ? getFormattedPhoneNumber(
                                                  physician.phone
                                              )
                                            : ''}
                                    </PhoneContainer>
                                </EmailPhoneGrid>
                            </BodyGridContainer>
                        );
                    })}
            </ProductGuideListContainer>
            <AccountPaginationWrapper>
                <DesktopView className="account-pagination-wrapper">
                    <PaginationContainer>
                        <BasicPagination
                            margin="12px 0px"
                            content={t(
                                'physicians.physicianList.showingPhysicians'
                            )}
                            iPadPaginatorInfoWidth={'100%'}
                            iPadPaginatorWidth={'100%'}
                            totalRecords={totalAssociatedPhysician || 0}
                            recordsFetched={
                                associatedPhysician &&
                                associatedPhysician.length
                            }
                            pageNumber={page}
                            handleChange={(e) => onPageChange(e)}
                            first={first}
                        />
                    </PaginationContainer>
                </DesktopView>
                <MobileView className="mobile-pagination-wrapper">
                    <PaginationContainerMobile padding={'15px'}>
                        <BasicPagination
                            mobilePadding={'2% 2% 2% 2%'}
                            content={t(
                                'physicians.physicianList.showingPhysicians'
                            )}
                            totalRecords={totalAssociatedPhysician || 0}
                            recordsFetched={
                                associatedPhysician &&
                                associatedPhysician.length
                            }
                            pageNumber={page}
                            handleChange={(e) => onPageChange(e)}
                            first={first}
                        />
                    </PaginationContainerMobile>
                </MobileView>
            </AccountPaginationWrapper>
            {showPopup && (
                <ModalDialog
                    modalHeight={'calc(100vh - 130px)'}
                    modalWidth={'70%'}
                    smalModalWidth={'85%'}
                    left={'7%'}
                    right={'7%'}
                    bottom={'10%'}
                    padding={'0px'}
                    handleClose={()=> physicianDetailsRef.current.handleClose()}
                    // isIPadPotrait={true}
                    zIndex={'2000'}
                    marginTop={'30%'}
                    top={'8%'}
                >
                    <AccountDetailsContainer>
                        <PhysicianDetails
                            ref={physicianDetailsRef}
                            accountDetail={physicianDetail}
                            handleClose={handleClose}
                            fromAccounts={true}
                            isFromAdmin={true}
                            setShowPopup={setShowPopup}
                            employeeRole={props.employeeRole}
                            //isFromAccount={true}
                        />
                    </AccountDetailsContainer>
                </ModalDialog>
            )}
        </>
    );
};
export default AssociatedPhysician;
